import { AfterViewInit, Component, Directive, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { IElectricalCable, ICcsTechnology } from '../../interfaces/IEquipmentData';


//#region EquipmentBaseComponent
// This base component reduces the amount of boilerplate needed , OnInitin each component since they are all very similar
@Directive()
export abstract class BaseComponent implements AfterViewInit {
  @Input() data$: any;
  @ViewChild('template_default') template_default: TemplateRef<any>;
  @ViewChild('template_mobile') template_mobile: TemplateRef<any>;

  currentTemplate: TemplateRef<any>;
  context = { title: '' };

  constructor() { }


  ngAfterViewInit() {
    this.updateTemplate(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateTemplate(event.target.innerWidth);
  }

  updateTemplate(width: number) {
    this.currentTemplate = width < 700 ? this.template_mobile : this.template_default;
  }
}
//#endregion  ------------------------------------------------





//#region FieldTypes ------------------------------------------------
@Component({
  selector: 'eic-field-types',
  templateUrl: './fieldTypes.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class FieldTypes extends BaseComponent implements OnInit {
  context = { title: 'Field Types' };
  fieldHydrocarbons: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }

  ngOnInit(): void {
    this.fieldHydrocarbons = this.data$
  }

}
//#endregion  ------------------------------------------------





//#region PowerCapacity ------------------------------------------------
@Component({
  selector: 'eic-power-capacity',
  templateUrl: './powerCapacity.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class PowerCapacity extends BaseComponent implements OnInit {
  context = { title: 'Power Capacity' };
  powerCapacity: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }

  ngOnInit(): void {
    this.powerCapacity = this.data$
  }
}
//#endregion  ------------------------------------------------





//#region PowerFuelTypes ------------------------------------------------
@Component({
  selector: 'eic-power-fuel-types',
  templateUrl: './powerFuelTypes.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class PowerFuelTypes extends BaseComponent implements OnInit {
  context = { title: 'Fuel Types' };
  fuelTypes: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.fuelTypes = this.data$
  }

}
//#endregion  ------------------------------------------------





//#region WindTurbines ------------------------------------------------
@Component({
  selector: 'eic-wind-turbines',
  templateUrl: './windTurbines.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class WindTurbines extends BaseComponent implements OnInit {
  context = { title: 'Wind Turbines' };
  windTurbines: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }

  ngOnInit(): void {
    this.windTurbines = this.data$
  }

  areAnyWindTurbinesOffshore(): boolean {
    return this.windTurbines.some(item => item.isOffshore === true);
  }
}
//#endregion  ------------------------------------------------





//#region LNGPlants ------------------------------------------------
@Component({
  selector: 'eic-lng-plants',
  templateUrl: './lngPlants.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class LNGPlants extends BaseComponent implements OnInit {
  context = { title: 'LNG Plants' };
  lngPlants: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.lngPlants = this.data$
  }

}
//#endregion Pipelines ------------------------------------------------





//#region Pipelines ------------------------------------------------
@Component({
  selector: 'eic-pipelines',
  templateUrl: './pipelines.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Pipelines extends BaseComponent implements OnInit {
  context = { title: 'Pipelines' };
  pipelines: any[];

  constructor() {
    super(); // Necessary to call the parent construc
  }

  ngOnInit(): void {
    this.pipelines = this.data$
  }
}
//#endregion  ------------------------------------------------





//#region Storage ------------------------------------------------
@Component({
  selector: 'eic-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Storage extends BaseComponent implements OnInit {
  context = { title: 'Storage' };
  storageStructures: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.storageStructures = this.data$;
  }
}

//#endregion  ------------------------------------------------





//#region Platforms -----------------------------------------------
@Component({
  selector: 'eic-platforms',
  templateUrl: './platforms.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Platforms extends BaseComponent implements OnInit {
  context = { title: 'Platforms' };
  platforms: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.platforms = this.data$
  }

}
//#endregion  ------------------------------------------------





//#region FloatingUnits ------------------------------------------------
@Component({
  selector: 'eic-floating-units',
  templateUrl: './floatingUnits.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class FloatingUnits extends BaseComponent implements OnInit {
  context = { title: 'Floating Units' };
  floatingUnits: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.floatingUnits = this.data$
  }

}
//#endregion  ------------------------------------------------




//#region SURF bits?? /////////////////////////////////////
// Arene't these all SURF????
//------------------------------------------------
// @Component({
//     selector: 'eic-flowlines',
//     template: `
//   <div *ngIf="data$ | async as flowlines">
//     <div style="page-break-inside: avoid">
//     <h5>Flowlines</h5>
//     <table class="optionalComponentSectionTable">
//       <tr style="font-weight: bold;"></tr>
//       <tr *ngFor="let flowline of flowlines"></tr>
//     </table>
//   </div>
// </div>`,
// })
// export class Flowlines {
//     @Input() data$: Observable<any>;
// }

// @Component({
//     selector: 'eic-risers',
//     template: `
//   <div *ngIf="data$ | async as risers">
//     <div style="page-break-inside: avoid">
//     <h5>Risers</h5>
//     <table class="optionalComponentSectionTable">
//       <tr style="font-weight: bold;"></tr>
//       <tr *ngFor="let riser of risers"></tr>
//     </table>
//   </div>
// </div>`,
// })
// export class Risers {
//     @Input() data$: Observable<any>;
// }

// @Component({
//     selector: 'eic-subsea-trees',
//     template: `
//   <div *ngIf="data$ | async as subseaTrees">
//     <div style="page-break-inside: avoid">
//     <h5>Subsea Trees</h5>
//     <table class="optionalComponentSectionTable">
//       <tr style="font-weight: bold;"></tr>
//       <tr *ngFor="let subseaTree of subseaTrees"></tr>
//     </table>
//   </div>
// </div>`,
// })
// export class SubseaTrees {
//     @Input() data$: Observable<any>;
// }

// @Component({
//     selector: 'eic-umbilicals',
//     template: `
//   <div *ngIf="data$ | async as umbilicals">
//     <div style="page-break-inside: avoid">
//     <h5>Umbilicals</h5>
//     <table class="optionalComponentSectionTable">
//       <tr style="font-weight: bold;"></tr>
//       <tr *ngFor="let umbilical of umbilicals"></tr>
//     </table>
//   </div>
// </div>`,
// })
// export class Umbilicals {
//     @Input() data$: Observable<any>;
// }

//#endregion ////////////////////////////////////////



//#region TidalTurbines -------------------------------------
@Component({
  selector: 'eic-tidal-turbines',
  templateUrl: './tidalTurbines.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class TidalTurbines extends BaseComponent implements OnInit {
  context = { title: 'Tidal Turbines' };
  tidalTurbines: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.tidalTurbines = this.data$;
  }
}
//#endregion   --------------------------------------



//#region Wells ------------------------------------------------
@Component({
  selector: 'eic-wells',
  templateUrl: './wells.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Wells extends BaseComponent implements OnInit {
  context = { title: 'Wells' };
  wells: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.wells = this.data$
  }
}
//#endregion  ------------------------------------------------





//#region ProcessFacilities ------------------------------------------------
@Component({
  selector: 'eic-process-facilities',
  templateUrl: './processFacilities.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class ProcessFacilities extends BaseComponent implements OnInit {
  context = { title: 'Process Facilities' };
  processFacilities: any;

  constructor() {
    super(); // Necessary to call the parent construc
  }
  ngOnInit(): void {
    this.processFacilities = this.data$
  }

}
//#endregion  ------------------------------------------------





//#region Terminals -------------------------------------
@Component({
  selector: 'eic-terminals',
  templateUrl: './terminals.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Terminals extends BaseComponent implements OnInit {
  context = { title: 'Terminals' };
  terminals: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.terminals = this.data$;
  }
}
//#endregion   --------------------------------------





//#region ElectricalCables -------------------------------------
// Exact electricalCableType values confirmed against live API payloads (IDs 1-3)
const ELECTRICAL_CABLE_TITLE_TO_TYPE: Record<string, string> = {
  'Inter-array Cables': 'Inter-Array Cable',
  'Power Export Cables': 'Power Export Cable',
  'Transmission Lines': 'Transmission Line'
};

@Component({
  selector: 'eic-electrical-cables',
  templateUrl: './electricalCables.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class ElectricalCables extends BaseComponent implements OnInit {
  context = { title: 'Electrical Cables' };
  electricalCables: IElectricalCable[] = [];
  cableCategories = Object.keys(ELECTRICAL_CABLE_TITLE_TO_TYPE);

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.electricalCables = this.data$ || [];
  }

  electricalCablesSubCollection(title: string): IElectricalCable[] {
    const expectedType = ELECTRICAL_CABLE_TITLE_TO_TYPE[title];
    if (!expectedType) return [];
    return this.electricalCables.filter(ec =>
      (ec.electricalCableType || '').trim().toLowerCase() === expectedType.toLowerCase()
    );
  }
}
//#endregion   --------------------------------------



//#region assetCarbonCapture -------------------------------------
@Component({
  selector: 'eic-ccs-technology-and-storage',
  templateUrl: './assetCarbonCapturePlants.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class AssetCarbonCapture extends BaseComponent implements OnInit {
  context = { title: 'Carbon Capture' };
  assetCarbonCapturePlants: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.assetCarbonCapturePlants = this.data$;
  }
}
//#endregion   --------------------------------------


//#region CCSTechnologyAndStorage -------------------------------------
@Component({
  selector: 'eic-ccs-technology-and-storage',
  templateUrl: './ccsTechnologyAndStorage.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class CCSTechnologyAndStorage extends BaseComponent implements OnInit {
  context = { title: 'CCS Technology and Storage' };
  ccsTechnology: ICcsTechnology;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.ccsTechnology = this.data$;
  }
}
//#endregion   --------------------------------------





//#region EmissionSystems -------------------------------------
@Component({
  selector: 'eic-emission-systems',
  templateUrl: './emissionSystems.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class EmissionSystems extends BaseComponent implements OnInit {
  context = { title: 'Emission Systems' };
  emissionSystems: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.emissionSystems = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Compressors -------------------------------------
@Component({
  selector: 'eic-compressors',
  templateUrl: './compressors.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Compressors extends BaseComponent implements OnInit {
  context = { title: 'Compressors' };
  compressors: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.compressors = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Manifolds -------------------------------------
@Component({
  selector: 'eic-manifolds',
  templateUrl: './manifolds.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Manifolds extends BaseComponent implements OnInit {
  context = { title: 'Manifolds' };
  manifolds: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.manifolds = this.data$;
  }
}
//#endregion   --------------------------------------





//#region GasProcessing -------------------------------------
@Component({
  selector: 'eic-gas-processing',
  templateUrl: './gasProcessing.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class GasProcessing extends BaseComponent implements OnInit {
  context = { title: 'Gas Processing' };
  gasProcessing: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.gasProcessing = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Solar -------------------------------------
@Component({
  selector: 'eic-solar',
  templateUrl: './solar.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Solar extends BaseComponent implements OnInit {
  context = { title: 'Solar' };
  solar: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.solar = this.data$;
  }
}
//#endregion   --------------------------------------





//#region WaveDevices -------------------------------------
@Component({
  selector: 'eic-wave-devices',
  templateUrl: './waveDevices.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class WaveDevices extends BaseComponent implements OnInit {
  context = { title: 'Wave Devices' };
  waveDevices: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.waveDevices = this.data$;
  }

  areAllWaveDevicesOffshore() {
    return this.waveDevices.every(item => item.offshore === true);
  }
}
//#endregion   --------------------------------------





//#region Geothermal -------------------------------------
@Component({
  selector: 'eic-geothermal',
  templateUrl: './geothermal.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Geothermal extends BaseComponent implements OnInit {
  context = { title: 'Geothermal' };
  geothermal: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.geothermal = this.data$;
  }
}
//#endregion   --------------------------------------





//#region DrillingFacilities -------------------------------------
@Component({
  selector: 'eic-drilling-facilities',
  templateUrl: './drillingFacilities.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class DrillingFacilities extends BaseComponent implements OnInit {
  context = { title: 'Drilling Facilities' };
  drillingFacilities: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.drillingFacilities = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Vessels -------------------------------------
@Component({
  selector: 'eic-vessels',
  templateUrl: './vessels.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Vessels extends BaseComponent implements OnInit {
  context = { title: 'Vessels' };
  vessels: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.vessels = this.data$;
  }
}
//#endregion   --------------------------------------





//#region AluminiumFacility -------------------------------------
@Component({
  selector: 'eic-aluminium-facility',
  templateUrl: './aluminiumFacility.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class AluminiumFacility extends BaseComponent implements OnInit {
  context = { title: 'Aluminium Facility' };
  aluminiumFacility: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.aluminiumFacility = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Plant -------------------------------------
@Component({
  selector: 'eic-plant',
  templateUrl: './plant.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Plant extends BaseComponent implements OnInit {
  context = { title: 'Plant' };
  plants: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.plants = this.data$;
  }
}
//#endregion   --------------------------------------





//#region Surf -------------------------------------
@Component({
  selector: 'eic-surf',
  templateUrl: './surf.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class Surf extends BaseComponent implements OnInit {
  context = { title: 'Surf' };
  surf: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.surf = this.data$;
  }
}
//#endregion   --------------------------------------





//#region CapexPackages -------------------------------------
@Component({
  selector: 'eic-capex-packages',
  templateUrl: './capexPackages.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class CapexPackages extends BaseComponent implements OnInit {
  context = { title: 'Capex Packages' };
  capexPackages: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.capexPackages = this.data$;
  }
}
//#endregion   --------------------------------------





//#region HydrogenCapacity -------------------------------------
@Component({
  selector: 'eic-hydrogen-capacity',
  templateUrl: './hydrogenCapacity.component.html',
  styleUrls: ['./equipment.styles.scss']
})
export class HydrogenCapacity extends BaseComponent implements OnInit {
  context = { title: 'Hydrogen Capacity' };
  hydrogenCapacity: any;

  constructor() {
    super(); // Necessary to call the parent constructor
  }

  ngOnInit(): void {
    this.hydrogenCapacity = this.data$;
  }
}
//#endregion   --------------------------------------